import http from 'utils/http';
import noproxy from 'utils/noproxy';
import { isAlreadyModeratedError, reportModerationActionError } from 'utils/moderationError';
import shouldFetchData from '../utils/shouldFetchData';

const requestTipsModeration = () => ({
  type: 'REQUEST_TIPS_MODERATION',
});

const requestTipsModerationBasket = () => ({
  type: 'REQUEST_TIPS_MODERATION_BASKET',
});

const receiveTipModeration = tipModeration => ({
  type: 'RECEIVE_TIP_MODERATION',
  tipModeration,
});

const receiveTipsModeration = tipsModeration => ({
  type: 'RECEIVE_TIPS_MODERATION',
  tipsModeration,
});

const receiveTipsModerationBasket = tipsModerationBasket => ({
  type: 'RECEIVE_TIPS_MODERATION_BASKET',
  tipsModerationBasket,
});

const receiveCurrentModeratorData = currentModerator => ({
  type: 'RECEIVE_CURRENT_MODERATOR_DATA',
  currentModerator,
});

const failureTipsModeration = () => ({
  type: 'FAILURE_TIPS_MODERATION',
});

const failureTipsModerationBasket = () => ({
  type: 'FAILURE_TIPS_MODERATION_BASKET',
});

const approveTipsModeration = mid => ({
  type: 'APPROVE_TIPS_MODERATION',
  mid,
});

const rejectTipsModeration = mid => ({
  type: 'REJECT_TIPS_MODERATION',
  mid,
});

const restoreTipsModeration = mid => ({
  type: 'RESTORE_TIPS_MODERATION',
  mid,
});

const rollbackApproveTipsModeration = tip => ({
  type: 'ROLLBACK_APPROVE_TIPS_MODERATION',
  tip,
});

const rollbackRejectTipsModeration = tip => ({
  type: 'ROLLBACK_REJECT_TIPS_MODERATION',
  tip,
});

const rollbackRestoreTipsModeration = tip => ({
  type: 'ROLLBACK_RESTORE_TIPS_MODERATION',
  tip,
});

const findModerationTip = (state, id) =>
  (state.tipsModeration.tipsModeration || []).find(tip => tip.id === id);

const findBasketTip = (state, id) =>
  (state.tipsModeration.tipsModerationBasket || []).find(tip => tip.id === id);

const fetchTipsModeration = () => async dispatch => {
  dispatch(requestTipsModeration());

  try {
    const response = await http.get('/user/tipsmoderation?limit=12');

    dispatch(receiveTipsModeration(response.data));
  } catch (error) {
    dispatch(failureTipsModeration());
  }
};

const fetchTipsModerationRecords = () => async dispatch => {
  dispatch(requestTipsModeration());

  try {
    const response = await http.get(`/user/tipsmoderation`);

    dispatch(receiveTipsModeration(response.data));
  } catch (error) {
    dispatch(failureTipsModeration());
  }
};

const fetchTipsModerationBasket = () => async dispatch => {
  dispatch(requestTipsModerationBasket());

  try {
    const response = await http.get(`/user/tipsmoderation/basket`);

    dispatch(receiveTipsModerationBasket(response.data));
  } catch (error) {
    dispatch(failureTipsModerationBasket());
  }
};

export const fetchTipsModerationIfNeeded = () => (dispatch, getState) => {
  const { tipsModeration } = getState();

  if (shouldFetchData(tipsModeration)) {
    dispatch(fetchTipsModeration());
  }
};

export const fetchTipsModerationForTipsListPage = () => dispatch => {
  dispatch(fetchTipsModerationRecords());
};

export const fetchTipsModerationBasketForModerators = () => dispatch => {
  dispatch(fetchTipsModerationBasket());
};

export const approveTipModeration = id => async (dispatch, getState) => {
  const tip = findModerationTip(getState(), id);
  dispatch(approveTipsModeration(id));

  try {
    await http.post(`/user/tipsmoderation/${id}/approve`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackApproveTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'approve', tipId: id });
  }
};

export const rejectTipModeration = id => async (dispatch, getState) => {
  const tip = findModerationTip(getState(), id);
  dispatch(rejectTipsModeration(id));

  try {
    await http.post(`/user/tipsmoderation/${id}/reject`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackRejectTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'reject', tipId: id });
  }
};

export const restoreTipModeration = id => async (dispatch, getState) => {
  const tip = findBasketTip(getState(), id);
  dispatch(restoreTipsModeration(id));

  try {
    await http.post(`/user/tipsmoderation/${id}/restore`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackRestoreTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'restore', tipId: id });
  }
};

export const displayModerationBasketModal = () => ({
  type: 'DISPLAY_MODERATION_BASKET_MODAL',
});

export const hideModerationBasketModal = () => ({
  type: 'HIDE_MODERATION_BASKET_MODAL',
});

export const fetchTipsExternalModerators = data => async dispatch => {
  dispatch(receiveTipsModeration(data));
};

export const fetchCurrentModerator = data => async dispatch => {
  dispatch(receiveCurrentModeratorData(data));
};

export const fetchBasketExternalModerators = data => async dispatch => {
  dispatch(receiveTipsModerationBasket(data));
};

export const approveModerationPanel = id => async (dispatch, getState) => {
  const tip = findModerationTip(getState(), id);
  dispatch(approveTipsModeration(id));

  try {
    await noproxy.post(`/moderationpanel/${id}/panelapprove`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackApproveTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'approve', tipId: id });
  }
};

export const rejectModerationPanel = id => async (dispatch, getState) => {
  const tip = findModerationTip(getState(), id);
  dispatch(rejectTipsModeration(id));

  try {
    await noproxy.post(`/moderationpanel/${id}/panelreject`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackRejectTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'reject', tipId: id });
  }
};

export const restoreModerationPanel = id => async (dispatch, getState) => {
  const tip = findBasketTip(getState(), id);
  dispatch(restoreTipsModeration(id));

  try {
    await noproxy.post(`/moderationpanel/${id}/panelrestore`);
  } catch (error) {
    if (tip && !isAlreadyModeratedError(error)) {
      dispatch(rollbackRestoreTipsModeration(tip));
    }
    reportModerationActionError(error, { action: 'restore', tipId: id });
  }
};

export const receivedTipModeration = tipModeration => dispatch =>
  dispatch(receiveTipModeration(tipModeration));

export const refreshModerations = id => async dispatch => {
  const { pathname } = window.location;
  const checkModeratorId = id || pathname.split('/')[2];

  try {
    const response = await noproxy.get(`/moderation/${checkModeratorId}`);
    dispatch(fetchTipsExternalModerators(response.data));
  } catch (error) {
    dispatch(failureTipsModeration());
  }
};

export const refreshBasket = id => async dispatch => {
  const { pathname } = window.location;
  const checkModeratorId = id || pathname.split('/')[2];

  try {
    const response = await noproxy.get(`/moderationbasket/${checkModeratorId}`);
    dispatch(fetchBasketExternalModerators(response.data));
  } catch (error) {
    dispatch(failureTipsModeration());
  }
};

export const toggleMessageAudio = mute => dispatch => {
  http.post('/user/toggle-message-audio').catch(error => {
    // eslint-disable-next-line no-console
    console.error(error);
  });
};

export const refreshTipsModerationListOnTip = tipsModeration => dispatch => {
  dispatch(receiveTipsModeration(tipsModeration));
};

/**
 * Lightweight panel sync from app.moderation.updated (no stream alert).
 * Apply locally so owner/moderator panels stay in sync without a refetch race.
 */
export const applyModerationPanelSync = payload => dispatch => {
  if (!payload || !payload.action) {
    return;
  }

  if (payload.action === 'approved') {
    dispatch({
      type: 'SYNC_MODERATION_APPROVED',
      id: payload.id,
      paymentId: payload.payment_id,
    });
    return;
  }

  if (payload.action === 'rejected') {
    dispatch({
      type: 'SYNC_MODERATION_REJECTED',
      id: payload.id,
      paymentId: payload.payment_id,
      rejectedAt: payload.rejected_at,
    });
    return;
  }

  if (payload.action === 'restored') {
    dispatch({
      type: 'SYNC_MODERATION_RESTORED',
      id: payload.id,
      paymentId: payload.payment_id,
    });
  }
};

export const receivedModerationPanelSync = payload => dispatch =>
  dispatch(applyModerationPanelSync(payload));
